/**
 * The command palette's entries, built from the product navigation.
 *
 * A pure module beside the view, so the node test suite can read it without
 * pulling in React, the CSS module, or the auth store.
 */

import { MessageSquare } from "lucide-react";
import {
  isProductTabVisible,
  visibleProductTabs,
  type OrgRendering,
  type ProductTopTab,
} from "../navigation";

export interface CommandEntry {
  id: string;
  label: string;
  hint: string;
  group: string;
  path: string;
  keywords: string;
  icon: ProductTopTab["icon"];
}

/**
 * The commands one organization may run.
 *
 * The palette is navigation, so it hides what the rail hides. `Assistant`
 * points at `/`, which is the Home product, so it goes with the Home tab.
 * `visibleProductTabs` and `isProductTabVisible` carry the default-open rule,
 * so an unanswered `/me` builds the full list.
 */
export function buildCommands(me: OrgRendering): CommandEntry[] {
  const out: CommandEntry[] = [];
  if (isProductTabVisible("home", me)) {
    out.push({
      id: "assistant:home",
      label: "Assistant",
      hint: "Open the assistant workspace (home)",
      group: "Assistant",
      path: "/",
      keywords: "assistant home chat workspace gauss",
      icon: MessageSquare,
    });
  }
  for (const product of visibleProductTabs(me)) {
    for (const item of product.items) {
      out.push({
        id: `${product.id}:${item.id}`,
        label: item.label,
        hint: item.description,
        group: product.label,
        path: item.path,
        keywords: `${item.label} ${item.description} ${product.label}`.toLowerCase(),
        icon: item.icon,
      });
    }
  }
  return out;
}
